import React from 'react';
import { Row, Col, Dropdown } from 'react-bootstrap';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { isValid } from '../../../../../../../utils/validationSummary';
import { withTranslation } from 'react-i18next';

/**
 * !! HAS A MODERN TWIN: projectProperties/modern/PropertyDropdown.jsx !!
 *
 * That file is a verbatim copy of everything in this class except render(). Any change
 * to the state machine, the handlers or componentDidUpdate MUST be mirrored there, or
 * the two will drift and screens will behave differently depending on which variant
 * they import. Only the layout is allowed to differ.
 *
 * This duplication is temporary: see the note in modern/PropertyDropdown.jsx for how to
 * collapse the two once the modern layout has settled.
 */
class PropertyDropdown extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            value: this.props.property.value,
        };

        this.handleChange = this.handleChange.bind(this);
    }

    renderDropdownItems() {
        let dropdownItems = [];
        this.props.properties.forEach(prop => {
            if (typeof prop === 'object') {
                dropdownItems.push(
                    <Dropdown.Item onClick={this.handleChange} name={prop.key} key={prop.key} >{this.getDisplayValue(prop.key)}</Dropdown.Item>
                );
            } else {
                dropdownItems.push(
                    <Dropdown.Item onClick={this.handleChange} name={prop} key={prop} >{this.getDisplayValue(prop)}</Dropdown.Item>
                );
            }
        });
        return dropdownItems;
    }

    handleChange(e) {
        const value = e.target.name;
        this.setState({ value: value });
        this.props.handleChange(this.props.property.info.name, value);
    }

    transformToValue(value) {
        for (let i = 0; i < this.props.properties.length; i++) {
            if (typeof this.props.properties[i] === 'object' && this.props.properties[i].key === +value) {
                return this.props.properties[i].value;
            }
        }
        return value;
    }

    getDisplayValue(value) {
        const { t } = this.props;
        var v = value
        if(this.props.translate && value !== undefined && value !== null && typeof(v) === 'string')
            v = t(value.replaceAll(' ', '_'));

        const valueTemp = this.transformToValue(v);
        return this.props.propertyDisplayFunc && valueTemp !== undefined && valueTemp !== null
            ? this.props.propertyDisplayFunc(valueTemp)
            : valueTemp;
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.property.value !== prevState.value) {
            this.setState({ value: this.props.property.value });
        }
    }

    render() {
        const className = `edit-icon-project-header dropdown-inventronics ${isValid(this.props.validationSummary, this.props.property) ? '' : 'danger'}`;
        const displayValue = this.getDisplayValue(this.state.value);
        const style = this.props.dropdownStyle || {};
        return (
            <Row style={{ margin: this.props.margin }}>
                {this.props.title ? (<Col sm={this.props.titleSize || 4} style={{ padding: this.props.paddingTitle }}>{this.props.title}</Col>) : null}

                <Col sm={this.props.dropdownSize || 5} style={{ padding: "0", ...style }}>
                    <Dropdown style={this.props.dropdownStyle}>
                        <Dropdown.Toggle variant="secondary" disabled={this.props.disabled || this.props.properties.length <= 1} className={className}>{displayValue}</Dropdown.Toggle>
                        <Dropdown.Menu style={{ minWidth: "auto", fontSize: "14px" }}>
                            {this.renderDropdownItems()}
                        </Dropdown.Menu>
                    </Dropdown>
                </Col>

                {this.props.measureUnit ? (<Col sm={this.props.measureUnitSize || 3} style={{ paddingLeft: '0.5rem' }}>{this.props.measureUnit}</Col>) : null}
            </Row>
        );
    };
}

const mapStateToProps = (state, ownProps) => {
    return {
        validationSummary: state.project.validationSummary,
    };
};

const mapDispatchToProps = {
}

// export default connect(
//     mapStateToProps,
//     mapDispatchToProps
// )(PropertyDropdown);

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps),
    withTranslation()
)(PropertyDropdown);
